import { render } from "./ClientSidebar.vue?vue&type=template&id=ad6ae934&scoped=true"
import script from "./ClientSidebar.vue?vue&type=script&lang=js"
export * from "./ClientSidebar.vue?vue&type=script&lang=js"

import "./ClientSidebar.vue?vue&type=style&index=0&id=ad6ae934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6ae934"]])

export default __exports__